export default "__VITE_ASSET__2PC8VV1M__"